<data-table *ngIf="content" [plainData]="content" [columns]="columns" [searchAll]="true" (check)="checked($event)" [noCard]="true"
                [newHeader]="true" [title]="titleTranslation | translate"></data-table>
<data-table *ngIf="service" [dataProvider]="service" [dataProviderParams]="params" [columns]="columns" [searchAll]="true"
                [newHeader]="true" [noCard]="true" (check)="checked($event)" [title]="titleTranslation | translate"></data-table>
<div class="buttons">
  <button (click)="abort()" class="ibexfusion-raised-button" mat-button>{{ 'general.cancel' | translate }}</button>
  <button (click)="save()" class="ibexfusion-raised-button" mat-button>{{ 'general.add' | translate }}</button>
</div>
